import { FieldPath, FieldValues, UseControllerProps, useController } from "react-hook-form";
import { YesNoInput } from "../inputs/YesNoInput";

export type FormYesNoProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = UseControllerProps<TFieldValues, FieldPath<TFieldValues>, TTransformedValues> & {
	errorMessage?: string;
	deselectable?: boolean;
	compact?: boolean;
	testId?: string;
};

export const FormYesNo = <TFieldValues extends FieldValues, TTransformedValues = TFieldValues>({
	control,
	defaultValue,
	disabled,
	name,
	errorMessage,
	deselectable,
	compact,
	testId,
	rules,
}: FormYesNoProps<TFieldValues, TTransformedValues>) => {
	const {
		field,
		fieldState: { error },
	} = useController({
		name,
		control,
		defaultValue,
		disabled,
		rules,
	});

	return (
		<YesNoInput
			value={field.value}
			onChange={field.onChange}
			onBlur={field.onBlur}
			deselectable={deselectable ?? false}
			error={error}
			errorMessage={errorMessage}
			compact={compact}
			testId={testId}
			disabled={disabled}
		/>
	);
};
